exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".red_shape.small_size{height: auto !important;}\n.mat-dialog-title{line-height: 25px;}\n.mat-input-container{width: 100% !important;}\n.mat-select{margin-top: 12px !important;}\n.outer_width{width:900px;}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/html/nissco_event_web/angular/src/app/supplier/profile/edit-attendee/edit-attendee.component.css
// module id = ../../../../../src/app/supplier/profile/edit-attendee/edit-attendee.component.css
// module chunks = 39